<template>
  <el-card shadow="always" v-if="state == 'CHANGED'">
    <div slot="header" class="clearfix">
      <span>Remetente</span>
    </div>
    <div>
      <el-form ref="form" :model="remetenteForm" :label-position="labelPosition" label-width="120px">
        <el-form-item class="no-margin-bottom" :label="$t('remetente')" prop="sender">
          <el-row :gutter="5">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <SenderList ref="senderList" v-model="remetenteForm.sender" :customer="customer" v-on:clear="clear" />
            </el-col>
          </el-row>
        </el-form-item>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item class="no-margin-bottom" label="Contato" :required="true">
              <el-input maxlength="50" v-model="remetenteForm.contact"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item class="no-margin-bottom" label="CPF/CNPJ" :required="true">
              <el-input v-mask="['NNN.NNN.NNN-NN', 'NN.NNN.NNN/NNNN-##']" v-model="remetenteForm.federalId"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="18" :sm="18" :md="18" :lg="12" :xl="12">
            <el-form-item class="no-margin-bottom" :label="$t('cep')" prop="cep" :required="true">
              <el-input maxlength="9" v-model="remetenteForm.cep" v-mask="'#####-###'" v-loading="loading"
                @blur="zipcode()"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item :label="$t('endereco')" prop="address" class="no-margin-bottom" :required="true">
              <el-input maxlength="50" v-model="remetenteForm.address"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="10">
            <el-form-item :label="$t('bairro')" prop="neighborhood" class="no-margin-bottom" :required="true">
              <el-input v-model="remetenteForm.neighborhood" maxlength="40"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
            <el-form-item class="no-margin-bottom" :label="$t('cidade')" prop="city" :required="true">
              <el-input v-model="remetenteForm.city" maxlength="40"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="6">
            <el-form-item class="no-margin-bottom" :label="$t('estado')" prop="state" :required="true">
              <el-input v-model="remetenteForm.state" maxlength="2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="10" :xl="6">
            <el-form-item class="no-margin-bottom" label="Número" :required="true">
              <el-input v-model="remetenteForm.number" maxlength="6"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="14" :xl="18">
            <el-form-item class="no-margin-bottom" label="Complemento">
              <el-input maxlength="40" v-model="remetenteForm.extent"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="bottom clearfix">
          <el-button type="success" title="Salva o remetente no sistema" @click="save()">Salvar</el-button>
        </div>
      </el-form>
    </div>
  </el-card>
  <el-card v-else shadow="always" style="min-height: 143px">
    <el-row :gutter="5">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <label style="font-weight: bold">Remetente:</label>&nbsp;
        <label>{{ remetenteForm.contact }}</label>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="18" :sm="18" :md="18" :lg="6" :xl="6">
        <label style="font-weight: bold">CEP:</label>&nbsp;
        <label>{{ remetenteForm.cep }}</label>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
        <label style="font-weight: bold">Endereço:</label>&nbsp;
        <label>{{ remetenteForm.address }}</label>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="18" :sm="18" :md="18" :lg="12" :xl="12">
        <label style="font-weight: bold">Bairro:</label>&nbsp;
        <label>{{ remetenteForm.neighborhood }}</label>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <label style="font-weight: bold">Cidade:</label>&nbsp;
        <label>{{ remetenteForm.city }} - {{ remetenteForm.state }} </label>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="18" :sm="18" :md="18" :lg="12" :xl="12">
        <label style="font-weight: bold">Complemento:</label>&nbsp;
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <el-button type="info" @click="changed" size="mini">Alterar</el-button>
      </el-col>
    </el-row>
  </el-card>
</template>
<script>
//import { UserService } from "@/services/users/user.services";
import { i18n } from "@/plugin/i18n";
import { CustomerService } from "@/services/customers/customers.services";
import { PostOfficeService } from "@/services/post.office/post.office.services";
import { SendersService } from "@/services/senders/senders.services";
import { UserService } from "@/services/users/user.services";
import FederalId from "@/xpost/components/FederalId";
import SenderList from "@/xpost/views/register/sender/SenderList";
import Vue from "vue";

export default {
  name: "PrePostSender",
  components: {
    FederalId,
    SenderList,
  },
  props: ["customer", "state", "labelPosition"],
  methods: {
    fetchSender() {
      const vm = this;
      if (!vm.remetenteForm.sender) {
        return false;
      }
      SendersService.get(vm.remetenteForm.sender)
        .then((response) => {
          vm.remetenteForm.cep = response.zipcode;
          vm.remetenteForm.contact = response.name;
          vm.remetenteForm.address = response.address;
          vm.remetenteForm.neighborhood = response.neighborhood;
          vm.remetenteForm.city = response.city;
          vm.remetenteForm.federalId = response.federalId;
          vm.remetenteForm.state = response.state;
          vm.remetenteForm.number = response.number;
          vm.remetenteForm.extent = response.complement;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    },
    zipcode: function () {
      const vm = this;
      if (!vm.remetenteForm.cep) {
        return false;
      }
      const loading = vm.$loading(vm.$options.loading);
      PostOfficeService.zipcode(vm.remetenteForm.cep)
        .then((response) => {
          vm.remetenteForm.address = response.end;
          vm.remetenteForm.city = response.cidade;
          vm.remetenteForm.state = response.uf;
          vm.remetenteForm.neighborhood = response.bairro;

          if (!response.uf) {
            this.$message({
              type: "warning",
              message: "Serviços dos correios temporariamente indisponível, não foi possível consultar os dados do CEP!",
              duration: 5000,
            });
          }

        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: i18n.tc("cep-invalido"),
            duration: 5000,
          });
        })
        .finally(() => loading.close());
    },
    validate() {
      const vm = this;
      return (
        vm.remetenteForm.cep &&
        vm.remetenteForm.address &&
        vm.remetenteForm.neighborhood &&
        vm.remetenteForm.city &&
        vm.remetenteForm.state &&
        vm.remetenteForm.contact &&
        vm.remetenteForm.number
      );
    },
    changed() {
      const vm = this;
      vm.$emit("changed");
    },
    fetchCustomer() {
      const vm = this;
      if (!vm.$props.customer) {
        return false;
      }
      CustomerService.get(vm.$props.customer)
        .then((response) => {
          if (response.cardpost && response.cardpost.length == 0) {
            this.$message({
              type: "warning",
              message: "Cliente sem cartão de postagem relacionado!",
              duration: 5000,
            });
          }
          setTimeout(() => {
            vm.remetenteForm.cep = response.zipcode.zipcode;
          }, 300);
          vm.remetenteForm.federalId = response.federalid;
          vm.remetenteForm.address = response.zipcode.address;
          vm.remetenteForm.neighborhood = response.zipcode.neighborhood;
          vm.remetenteForm.city = response.zipcode.city;
          vm.remetenteForm.state = response.zipcode.state;
          vm.remetenteForm.number = response.number;
          vm.remetenteForm.extent = response.extent;
          Vue.set(vm.remetenteForm, "cep", response.zipcode.zipcode);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            duration: 5000,
            message: error,
          });
        })
        .finally(() => (vm.loading = false));
    },
    save() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      SendersService.add({
        customer: vm.customer,
        name: vm.remetenteForm.contact,
        federalId: vm.remetenteForm.federalId,
        zipcode: vm.remetenteForm.cep,
        address: vm.remetenteForm.address,
        neighborhood: vm.remetenteForm.neighborhood,
        city: vm.remetenteForm.city,
        state: vm.remetenteForm.state,
        number: vm.remetenteForm.number,
        complement: vm.remetenteForm.extent,
      })
        .then((response) => {
          if (vm.$refs.senderList) vm.$refs.senderList.fetchSenders();
          this.$message({
            type: "success",
            message: i18n.tc("remetente-criado-sucesso"),
            duration: 5000,
          });
        }).catch((error) => {
          this.$message({
            type: "error",
            message: error,
            duration: 5000,
          });
        })
        .finally(() => loading.close());
    },
    clear() {
      const vm = this;
      vm.remetenteForm.cep = "";
      vm.remetenteForm.contact = "";
      vm.remetenteForm.address = "";
      vm.remetenteForm.neighborhood = "";
      vm.remetenteForm.city = "";
      vm.remetenteForm.state = "";
      vm.remetenteForm.number = "";
      vm.remetenteForm.extent = "";
      vm.remetenteForm.federalId = "";
      vm.fetchCustomer();
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        if (response.customers && response.customers.length > 0) {
          vm.$props.customer = response.customers[0];
        }
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
          duration: 5000,
        });
      });
  },
  watch: {
    customer: function (v) {
      const vm = this;
      vm.fetchCustomer();
    },
    "remetenteForm.sender": function (newVal, oldVal) {
      const vm = this;
      vm.fetchSender();
    },
    state: function (v) {
      const vm = this;
    },
  },
  data() {
    return {
      loading: false,
      remetenteForm: {
        sender: '',
        cep: "",
        federalId: "",
        contact: "",
        address: "",
        neighborhood: "",
        city: "",
        state: "",
        number: "",
        extent: "",
      },
    };
  },
};
</script>
